import { Avatar, DialogContent, DialogTitle, Stack, Typography } from "@mui/material";
import { Fake } from "components/layout/skeleton/Fake";
import { SkeletonTable } from "components/layout/skeleton/SkeletonTable";

export const RankingsDialogSkeleton = () => (
    <div className="skeleton" role="status" aria-label="loading">
        <DialogTitle>
            <Stack direction="row" spacing={1} marginTop={1}>
                <Avatar/>
                <Fake size={30} />
            </Stack>
            <Stack direction="row" marginY={2}>
                <Stack spacing={1} marginRight="auto">
                    <Typography>
                        <Fake size={30} />
                    </Typography>
                    <Typography>
                        <Fake size={20} />
                    </Typography>
                </Stack>
                <Stack spacing={1} marginRight={4}>
                    <Typography>
                        <Fake size={12} />
                    </Typography>
                    <Typography>
                        <Fake size={6} />
                    </Typography>
                </Stack>
                <Stack spacing={1}>
                    <Typography>
                        <Fake size={24} />
                    </Typography>
                    <Typography>
                        <Fake size={14} />
                    </Typography>
                </Stack>
            </Stack>
        </DialogTitle>

        <DialogContent>
            <SkeletonTable withoutAvatar rows={2} />
        </DialogContent>
    </div>
);
